
define('text!views/common/footer.html',[],function () { return '<footer class="page-footer"><!--ko if:localStorage.getItem(\'show_copyright\') == 1 --> <span class="login-footer-text">Copyright © <span data-bind="text: contact_us_modal.contact_us.params.current_year"></span> Acquired Ltd. All rights reserved. </span><!-- /ko --></footer>';});

